import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let sdk = null;

const loadCashfree = () =>
  sdk ||
  (sdk = new Promise((resolve, reject) => {
    if (window.Cashfree) return resolve();
    const s = document.createElement("script");
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.onload = resolve;
    s.onerror = () => {
      sdk = null;
      reject(new Error("Could not load the payment window. Check your connection and try again."));
    };
    document.body.appendChild(s);
  }));

export const verifyPayment = (orderId) => axios.post(`${API}/payment/verify`, { order_id: orderId }).then((r) => r.data);

export async function payWithCashfree(order, { onPaid, onError }) {
  await loadCashfree();
  const cashfree = window.Cashfree({ mode: order.cashfree_mode });
  const result = await cashfree.checkout({ paymentSessionId: order.payment_session_id, redirectTarget: "_self" });
  if (result?.error) onError(result.error.message || "Could not open the payment page. Please try again.");
}
